// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"Filtro.styles_dataTableFormat__3LF-a","formSpace":"Filtro.styles_formSpace__nMHUC"};